/* eslint-disable camelcase */
import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';
import { axiosInstance } from 'hb-react/shared/utils/axios';

const getTopicMenuPath = (args: { topicId: number; whitelabelURL: string }) => {
  const { topicId, whitelabelURL } = args;

  return dynamicTopicResourcePath(
    Routes.menu_topic_path(topicId, { format: 'json' }),
    {
      whitelabelURL,
      topicId,
    },
  );
};

interface UseTopicMenu {
  key?: string[];
  enabled?: boolean;
  topic: {
    id: number;
    app_pages?: any[];
  };
}

export const useTopicMenu = ({ enabled = true, topic }: UseTopicMenu) => {
  // If used not in TopicContext, it will use the default values of the context.
  const { whitelabelURL } = useTopicContext();

  const topicId = topic?.id;

  const { data, isLoading } = useQuery({
    queryKey: ['topic', topicId, 'menu'],
    queryFn: () =>
      axiosInstance
        .get(
          getTopicMenuPath({
            topicId,
            whitelabelURL,
          }),
        )
        .then(({ data }) => data),
    enabled,
    staleTime: ms('5m'),
  });

  return {
    appPages: data,
    isLoading,
  };
};
